export default "__VITE_ASSET__Bg4YFi8k__"